export default __webpack_public_path__ + "static/media/misc-books5-768w.357d84f5.png";